// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { endpoints } from '../../utils/Constants';
import { Button, Container, Row, Col } from 'reactstrap';
import { saveAs } from 'file-saver';
import useFetchSimple from '../../Services/useFetchSimple';
import UploadButton from '../Form/UploadButton'
import dayjs from 'dayjs'
import { showDate, showDateTime } from '../../utils/Helpers';
import { useAlert } from '../../Services/AlertContext';
import { useAuth } from '../../Services/AuthContext';
import SupplierDetail from '../Cards/SupplierDetail';
import DatePickerControl from '../Form/DatePicker';
import LoadingAnimation from '../Form/LoadingAnimation';
import { useCallback } from 'react';
import { ISupplierDocument } from '../../Models/ISupplierDocument';

const DocumentDetails = ({ index, route, doc, refresh, supplierId }: { optional?: true, index?: string, route?: string, doc: ISupplierDocument, refresh: () => void, supplierId: string }) => {


    const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays: Uint8Array[] = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    const blobToBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const [newFile, setFile] = useState();

    const { fileName, fileCategory, lastChecked, checkedByUser, expiredAt, status, id } = doc;
    const approved = status === 'Current' || status === 'Nearly Expired';

    const [approving, setApproving] = useState();
    const [expireDate, setExpire] = useState<void | Date>();
    const [uploading, setUploading] = useState(false);
    const fetch = useFetchSimple();
    const [gettingDocument, setGettingDocument] = useState(false);
    const alert = useAlert();
    const [auth] = useAuth();

    const downloadDoc = async () => {
        setGettingDocument(true);
        const result = await fetch(endpoints.getSupplierDocument + id);
        if (result.body) {
            const blob = b64toBlob(result.body.file, "application/pdf")
            setGettingDocument(false);
            saveAs(blob, fileName);
        }
    }
    const uploadFile = useCallback(async (e?: unknown) => {


        setUploading(true);
        const approved = false;
        const file64 = await blobToBase64(e);

        const file = file64.split(',')[1];
        const fileName = e.name;
        const newDoc = { ...doc, file, fileName, approved };

        fetch(endpoints.updateSupplierDocument + supplierId, { method: 'POST', body: JSON.stringify(newDoc) }).then((result) => {
            const { body } = result;
            if (!body.success) {
                alert({ title: 'Error uploading document', body: <div> <h6>{body.messages.map(x => x)}</h6></div> });
            }
            setFile();

            setUploading(false);
            refresh && refresh();
        }, (error) => { alert({ title: "Error:", body: JSON.stringify(error) }) }
        );
    }, [refresh, supplierId, alert, doc, fetch]);


    const cancelApprove = () => {
        setUploading(true)
        const approved = false;
        const approvedBy = '';
        const newDoc = { ...doc, approved, approvedBy, file: null };
        fetch(endpoints.updateSupplierDocument + supplierId, { method: 'POST', body: JSON.stringify(newDoc) }).then((result) => {
            const { body } = result;
            if (!body.success) {
                alert({ title: 'Error cancelling approval', body: <div><h6>{body.messages.map(x => x)}</h6></div> });
            }
            refresh && refresh();
            setUploading(false);
        }, (error) => {
            alert({ title: 'Error', body: JSON.stringify(error) });
            setUploading(false);
        })
    };


    const approveDocument = () => {
        if (approving) {
            const approvedBy = '';
            const expiredAt = dayjs(expireDate).format('YYYY-MM-DDTHH:mm:ss');
            const newDoc = { ...doc, approved: true, approvedBy, expiredAt, file: null };
            setUploading(true);
            fetch(endpoints.updateSupplierDocument + supplierId, { method: 'POST', body: JSON.stringify(newDoc) }).then((result) => {
                const { body } = result;
                if (!body.success) {
                    alert({ title: 'Error approving document', body: <div> <h6>{body.messages.map(x => x)}</h6></div> });
                }
                setUploading(false);

                refresh && refresh();
            }, (error) => alert({ title: 'error', body: JSON.stringify(error) }));
            setApproving(false);
            setExpire();
        }
        else {
            setApproving(true);
        }


    }
    useEffect(() => {
        if (newFile) {
            uploadFile()
        }
    }, [newFile, uploadFile])
    const color = status === "Current" ? 'green' : status === "Nearly Expired" ? 'orange' : 'red';
    const admin = auth.role === "Admin"
    const category = fileCategory.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1")
    return <Container style={{ zIndex: 0, borderWidth: '5px', borderStyle: 'solid', borderColor: color, marginBottom: '15px' }}>

        <b>{category}</b>
        <Col>
            <Row>

                <Col>
                    {doc.supplier ? <Row style={{ zIndex: 0, padding: '5px' }} ><SupplierDetail index={index} supplier={doc.supplier} route={route} /></Row> : null}
                    <Row style={{ zIndex: 0, padding: '5px' }}>{fileName}</Row>
                    <Row style={{ zIndex: 0, padding: '5px' }}>{fileName ? !gettingDocument ? < Button onClick={downloadDoc} >Download</Button> : <LoadingAnimation height='15px' /> : "No File."}</Row>
                    <Row style={{ zIndex: 0, padding: '5px' }}><UploadButton handleChange={uploadFile} >{fileName ? 'Replace ' : 'Upload'}</UploadButton></Row>
                </Col>
                {uploading ? 'Uploading' : <Col>
                    <Row style={{ zIndex: 0 }}>
                        {status}
                    </Row>
                    <Row style={{ zIndex: 0 }}>
                        {fileName && !newFile && approved ? 'Approved by : ' + checkedByUser?.userName : null}
                    </Row>
                    <Row style={{ zIndex: 0 }}>
                        {fileName && !newFile && approved ? '\nLast Checked :' + showDateTime(lastChecked) : null}
                    </Row>
                    <Row style={{ zIndex: 0 }}>
                        {(fileName && !newFile && approved) || approving ? '\nExpires:' : null}
                        {fileName && !newFile && approved && !approving ? showDate(expiredAt) : null}
                        {status === "Expired" ? '\nExpired:' : null}
                        {status === "Expired" ? showDate(expiredAt) : null}
                    </Row>
                    <Row style={{ zIndex: 0, marginTop: '5px', marginBottom: '5px' }}>
                        {fileName && !newFile && approving ?
                            <DatePickerControl style={{ zIndex: 99990, marginTop: '5px', marginBottom: '5px' }} selected={expireDate} onChange={(e) => setExpire(e)} type='date' />
                            : null}
                        {fileName && admin && !newFile && approved && !approving ? <Button style={{ zIndex: 0, marginBottom: '5px', paddingBottom: '5px' }} onClick={cancelApprove} >Cancel Approval</Button> : null}
                        {fileName && admin && !newFile && !approved && !approving ? < Button style={{ zIndex: 0, marginBottom: '5px', paddingBottom: '5px' }} onClick={approveDocument}>Approve</Button> : null}
                        {fileName && admin && !newFile && !approved && approving && expireDate ? < Button style={{ zIndex: 0, marginBottom: '5px', paddingBottom: '5px' }} onClick={approveDocument}>Approve</Button> : null}

                    </Row>
                </Col>}

            </Row>
        </Col>
    </Container>
}


export default DocumentDetails;